<template>
	<div>
		<flCabecalhoForm
			:msg="_traducao('global', 'obrigatorio')"
			color="#1976D2"
			cls="print-titulo-form-40"
			:texto="_traducao('global', 'passageirosDaAeronave')"
		/>

		<div class="row">
			<!-- ha passageiros? -->
			<div
				class="col-xs-12 col-md-2 form-group"
				:class="{'has-error': form.erro_existe_passageiro != ''}"
			>
				<label>* {{ _traducao('global', 'haPassageiros') }}</label>
				<br />
				<div class="btn-group print-button-group" role="group">
					<flSimNao v-model="form.existe_passageiro" :disabled="disabled" />
				</div>
				<p class="help-block" v-show="form.erro_existe_passageiro != ''">
					{{ form.erro_existe_passageiro }}
				</p>
			</div>

			<div
				class="col-xs-8 col-md-2 form-group"
				:class="{'has-error': form.erro_passageiros}"
				v-show="form.existe_passageiro"
			>
				<label>{{ _traducao('global', 'quantos') }}</label>
				<br />
				<a
					href="#"
					class="pass-btn-mais text-center"
					@click.prevent="addPassageiro('+')"
					:class="{disabled: disabled}"
				>
					<i style="margin-top: 7px" class="fa fa-plus fa-fw"></i>
				</a>
				<a
					href="#"
					class="pass-btn-menos text-center"
					@click.prevent="addPassageiro('-')"
					:class="{disabled: disabled}"
				>
					<i style="margin-top: 8px" class="fa fa-minus fa-fw"></i>
				</a>
				<input
					type="text"
					:value="form.passageiros"
					style="cursor: default; background: #fff"
					v-mask="'00'"
					disabled="disabled"
					class="form-control text-center input-sm"
				/>

				<p class="help-block" v-show="form.erro_passageiros != ''">
					{{ form.erro_passageiros }}
				</p>
			</div>

			<div
				class="col-xs-8 col-md-2 form-group"
				:class="{'has-error': form.erro_quantidade_estimada_passageiros}"
				v-show="form.existe_passageiro"
			>
				<label>
					{{ _traducao('global', 'quantidadeEstimadaPassageiros') }}:</label
				>
				<button
					type="button"
					class="pass-btn-mais-btn btn-link text-center"
					@click.prevent="addQuantidadeEstimada()"
				>
					<i style="margin-top: 7px" class="fa fa-plus fa-fw"></i>
				</button>
				<button
					type="button"
					:disabled="form.quantidade_estimada_passageiros == 0"
					class="pass-btn-menos-btn btn-link text-center"
					@click.prevent="subQuantidadeEstimada()"
				>
					<i style="margin-top: 8px" class="fa fa-minus fa-fw"></i>
				</button>
				<input
					type="text"
					:value="form.quantidade_estimada_passageiros"
					style="cursor: default; background: #fff"
					v-mask="'00'"
					disabled="disabled"
					class="form-control text-center input-sm"
				/>
				<p
					class="help-block"
					v-show="form.erro_quantidade_estimada_passageiros != ''"
				>
					{{ form.erro_quantidade_estimada_passageiros }}
				</p>
			</div>

			<div class="col-xs-4 col-md-2 form-group" v-show="form.existe_passageiro">
				<label>{{ _traducao('global', 'grupo') }}: </label>
				<select
					v-model="grupoSelecionado"
					class="form-control input-sm"
					@change="carregarPassageiroGrupo"
				>
					<option :value="null">
						{{ _traducao('global', 'escolha').toUpperCase() }}
					</option>
					<option v-for="grupo in grupos" :value="grupo.id" :key="grupo.id">
						{{ grupo.descricao }}
					</option>
				</select>
			</div>
		</div>

		<!-- passageiros -->
		<div v-if="form.existe_passageiro">
			<div class="row">
				<div
					class="col-lg-4 col-xs-12"
					v-for="(passageiro, index) in form.passageiro"
					:key="index + 'P'"
				>
					<div class="trecho-borda" style="margin-bottom: 10px">
						<div class="row no-print">
							<div
								class="col-xs-12 form-group"
								:class="{'has-error': passageiro.nomeErro}"
							>
								<label
									><span class="no-print">*</span>
									{{ _traducao('global', 'nome') }}:</label
								>
								<div style="display: flex">
									<vue-select
										class="form-control input-sm"
										label="nome"
										:filterable="false"
										:disabled="disabled"
										@input="(val) => carregarPassageiro(val, index)"
										:value="passageiro"
										:options="listaPassageiros.lista"
										@open="onOpen"
										@close="onClose"
										@search="(query) => buscaServeSide(query)"
									>
										<template #list-footer>
											<li ref="load" class="loader" v-show="hasNextPage">
												{{ _traducao('global', 'carregandoMaisOpcoes') }}...
											</li>
										</template>
										<template #no-options>
											<li @click.prevent="">
												{{ _traducao('global', 'semPassageiros') }}
											</li>
										</template>
									</vue-select>
									<button
										type="button"
										class="btn btn-sm btn-info"
										style="margin-left: 5px"
										@click="abrirCadastroPassageiro(index)"
									>
										<i class="fa fa-plus fa-fw"></i>
									</button>
									<button
										class="btn btn-sm btn-danger"
										style="margin-left: 5px"
										@click="excluirPassageiro(passageiro)"
									>
										<i class="fa fa-trash fa-fw"></i>
									</button>
								</div>
								<p class="help-block" v-show="passageiro.nomeErro">
									{{ passageiro.nomeErro }}
								</p>
							</div>

							<!-- peso -->
							<div
								class="col-xs-6 form-group"
								:class="{'has-error': passageiro.pesoPassageiroErro}"
							>
								<label
									><span class="no-print">*</span>
									{{ _traducao('global', 'pesoAprox') }}:</label
								>
								<small class="solicitacao-previsao">(Kg)</small>
								<money
									v-model="passageiro.peso"
									v-bind="_vpercem(2)"
									class="form-control input-sm"
									:disabled="disabled"
								></money>
								<p
									class="help-block"
									style="position: absolute"
									v-show="passageiro.pesoPassageiroErro"
								>
									{{ passageiro.pesoPassageiroErro }}
								</p>
							</div>

							<!-- telefone -->
							<div class="col-xs-6 form-group">
								<label>{{ _traducao('global', 'telefone') }}:</label>
								<input
									:disabled="disabled"
									type="text"
									v-model="passageiro.telefone"
									v-mask="_vtelefone"
									class="form-control input-sm"
								/>
							</div>
						</div>

						<div class="row">
							<div class="col-xs-6 form-group">
								<label>
									<i
										v-show="passageiro.estrangeiro"
										style="font-size: 12px"
										v-tooltip="
											_traducao(
												'global',
												'oCampoDePassaporteEObrigatorioParaUmEstrangeiro'
											)
										"
										class="fa fa-info-circle text-info"
										aria-hidden="true"
									></i>
									{{ _traducao('global', 'eEstrangeiro') }}?
								</label>
								<br />
								<div class="btn-group print-button-group" role="group">
									<flSimNao
										v-model="passageiro.estrangeiro"
										@change="limparErrosAoAlterarEstrangeiro(passageiro)"
									/>
								</div>
							</div>

							<div
								class="col-xs-6 form-group"
								:class="{
									'has-error': passageiro.cpfErro,
									'col-xs-6': flagCompleto,
									'col-xs-6': !flagCompleto
								}"
								v-show="!passageiro.estrangeiro || flagCompleto"
							>
								<label
									><span v-show="!passageiro.estrangeiro">*</span>
									{{ _traducao('menuAGnovoUsuario', 'menuAGcpf') }}:</label
								>
								<!-- <input
									type="text"
									v-model="passageiro.cpf"
									v-mask="_vdocumento"
									class="form-control form-group input-sm"
									@blur="$emit('validar-cpf-passageiro', index, passageiro)"
								/> -->
								<vue-select
									class="form-control input-sm"
									label="cpf"
									:filterable="false"
									:disabled="disabled"
									@input="(val) => carregarPassageiro(val, index)"
									:value="passageiro"
									:options="listaPassageiros.lista"
									@open="onOpen"
									@close="onClose"
									@search="(query) => buscaServeSide(query)"
								>
									<template #list-footer>
										<li ref="load" class="loader" v-show="hasNextPage">
											{{ _traducao('global', 'carregandoMaisOpcoes') }}...
										</li>
									</template>
									<template #no-options>
										<li @click.prevent="">
											{{ _traducao('global', 'semPassageiros') }}
										</li>
									</template>
								</vue-select>
								<p class="help-block" v-show="passageiro.cpfErro">
									{{ passageiro.cpfErro }}
								</p>
							</div>
						</div>
						<div class="row">
							<input-text
								v-if="flagCompleto"
								class="col-xs-6 form-group"
								label="RG"
								v-model="passageiro.rg"
							/>
							<input-text
								v-if="flagCompleto"
								class="col-xs-6 form-group"
								:label="_traducao('global', 'matricula')"
								v-model="passageiro.matricula"
							/>
						</div>

						<div class="row">
							<input-text
								v-show="passageiro.estrangeiro || flagCompleto"
								class="form-group"
								:class="flagCompleto ? 'col-xs-6' : 'col-xs-12'"
								:label="_traducao('global', 'passaporte')"
								v-model="passageiro.passaporte"
								:mensagem-erro="passageiro.passaporteErro"
								:obrigatorio="passageiro.estrangeiro"
							/>

							<div class="col-xs-6 form-group" v-if="flagCompleto">
								<label>Atenção Especial:</label>
								<select
									:disabled="disabled"
									class="input-sm form-control"
									v-model="passageiro.atencao_especial"
								>
									<option value="">
										{{ _traducao('global', 'escolha').toUpperCase() }}
									</option>
									<option
										:value="atencao_especial.id"
										v-for="atencao_especial in listaAtencaoEspecial"
										:key="'atencao-especial-' + atencao_especial.id"
									>
										{{ atencao_especial.descricao }}
									</option>
								</select>
							</div>
							<input-select
								v-if="flagSimples || flagCompleto"
								class="col-xs-12 form-group"
								:label="_traducao('menuAGcadAluno', 'empresa')"
								:opcoes-objeto="orgaosApoiados"
								label-option="descricao"
								campo-valor="id"
								:disabled="disabled"
								v-model="passageiro.orgao"
							/>
						</div>

						<div class="row no-print">
							<!-- cargo -->
							<div
								class="col-xs-4 form-group"
								v-if="flagSimples || flagCompleto"
							>
								<label
									>{{ _traducao('menuRGordemmissao', 'menuOMcargo') }}:</label
								>
								<input
									:disabled="disabled"
									type="text"
									v-model="passageiro.cargo"
									class="form-control input-sm"
								/>
							</div>

							<div class="col-xs-8 form-group" v-if="flagCompleto">
								<label>Observação:</label>
								<input
									:disabled="disabled"
									type="text"
									v-model="passageiro.observacao"
									class="form-control input-sm"
								/>
							</div>

							<div class="col-xs-6 form-group" v-if="flagCompleto">
								<label>Peso Bagagem de Mão:</label>
								<small class="solicitacao-previsao">(Kg)</small>
								<money
									v-model="passageiro.peso_bagagem_mao"
									v-bind="_vpercem(2)"
									class="form-control input-sm"
									:disabled="disabled"
								></money>
							</div>

							<div class="col-xs-6 form-group" v-if="flagCompleto">
								<label>Peso Bagagem do Porão:</label>
								<small class="solicitacao-previsao">(Kg)</small>
								<money
									v-model="passageiro.peso_bagagem_porao"
									v-bind="_vpercem(2)"
									class="form-control input-sm"
									:disabled="disabled"
								></money>
							</div>

							<div class="col-xs-6 form-group" v-if="flagCompleto">
								<label>Valor Passagem:</label>
								<money
									v-model="passageiro.passagem"
									v-bind="_vpercem(2)"
									class="form-control input-sm"
									:disabled="disabled"
								></money>
							</div>

							<div class="col-xs-6 form-group" v-if="flagCompleto">
								<label>Hospedagem:</label>
								<div>
									<flSimNao
										:disabled="disabled"
										v-model="passageiro.hospedagem"
									/>
								</div>
							</div>

							<div
								class="col-xs-12"
								:class="{'has-error': passageiro.trechoErro}"
							>
								<label
									>{{ _traducao('global', 'desmarqueTrechosPass') }}:</label
								>
								<table
									class="table table-condensed"
									style="margin-bottom: 0px"
									v-if="possuiTrechos"
								>
									<tbody>
										<tr
											v-for="(trecho, idx) in passageiro.trecho"
											style="vertical-align: middle; cursor: pointer"
											@click="!disabled ? atualizarTrecho(trecho) : ''"
											:key="idx + 'T'"
											:style="{
												'background-color': trecho.esta
													? '#a9d796'
													: passageiro.trechoErro
													? '#C9302C'
													: '',
												'color': trecho.esta
													? 'black'
													: passageiro.trechoErro
													? 'white'
													: 'black'
											}"
										>
											<td class="text-left" style="width: 50%">
												<small style="font-size: 10px; font-weight: 700">
													{{
														trecho.pais_partida
															? trecho.pais_partida.descricao
															: ''
													}} </small
												><br />
												<small style="font-size: 10px; font-weight: 700">
													{{
														trecho.designativo_partida
															? trecho.designativo_partida.cidade
															: ''
													}}
													-
													{{
														trecho.estado_partida
															? trecho.estado_partida.nome
															: ''
													}} </small
												><br />
												<small style="font-size: 10px; font-weight: 700">
													({{
														trecho.designativo_partida
															? trecho.designativo_partida.sigla
															: ''
													}})
													{{
														trecho.designativo_partida
															? trecho.designativo_partida.local
															: ''
													}}
													<br />
													{{ trecho.descricao_partida }}
												</small>
											</td>
											<td class="text-center" style="vertical-align: middle">
												<i
													class="fa fa-arrow-right"
													style="font-size: 12px"
													aria-hidden="true"
												></i>
												<i
													class="fa fa-chevron-down"
													v-if="idx < passageiro.trecho.length - 1"
													style="font-size: 10px"
													aria-hidden="true"
												></i>
											</td>
											<td
												class="text-right"
												style="width: 50%; vertical-align: middle"
											>
												<small style="font-size: 10px; font-weight: 700">
													{{
														trecho.pais_destino
															? trecho.pais_destino.descricao
															: ''
													}} </small
												><br />
												<small style="font-size: 10px; font-weight: 700">
													{{ trecho.estado_destino.nome }}
													-
													{{ trecho.designativo_destino.cidade }} </small
												><br />
												<small
													style="font-size: 10px; font-weight: 700"
													v-if="!trecho.nao_tem_aerodromo"
												>
													({{ trecho.designativo_destino.sigla }})
													{{ trecho.designativo_destino.local }}

													{{ trecho.descricao_destino }}
												</small>
												<small
													style="font-size: 10px; font-weight: 700"
													v-if="trecho.nao_tem_aerodromo"
												>
													<br />
												</small>
											</td>
										</tr>
									</tbody>
									<p class="help-block" v-show="passageiro.trechoErro">
										{{ passageiro.trechoErro }}
									</p>
								</table>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<modal ref="formCadastroPassageiro">
			<div class="row">
				<div class="col-xs-12">
					<h4>
						{{ _traducao('global', 'cadastroPassageiros').toUpperCase() }}
						<button
							type="button"
							class="close"
							@click="$refs.formCadastroPassageiro.modalHide()"
						>
							<span aria-hidden="true">&times;</span>
						</button>
					</h4>
					<hr />
				</div>
				<flFormCadastroPassageiro
					:is-not-modal="false"
					@passageiro-salvo="carregarPassageiroRecemSalvo"
				/>
			</div>
		</modal>
	</div>
</template>
<script>
import flFormCadastroPassageiro from '@/modules/layout/admin-geral/cadastro-passageiros/form/main.vue'

export default {
	components: {flFormCadastroPassageiro},
	props: {
		form: {
			type: Object,
			required: true
		},
		disabled: {
			type: Boolean,
			default: false
		},
		possuiTrechos: {
			type: Boolean,
			default: true
		}
	},
	data() {
		return {
			passageirosExcluidos: [],
			listaAtencaoEspecial: [],
			indexCadastro: null,
			orgaosApoiados: [],
			grupos: [],
			grupoSelecionado: null,
			listaPassageiros: [],
			passageiros: [],
			flagComponente: $cliente.get('componente_passageiro_solicitacao'),
			observer: null,
			limit: 10,
			search: '',
			timeBusca: null
		}
	},
	watch: {
		'form.existe_passageiro': function (val) {
			if (val) {
				if (this.form.id == 0) {
					this.addPassageiro('+')
				}
			} else {
				this.form.passageiro = []
				this.form.passageiros = 0
			}
		},
		'search'(novo, antigo) {
			if (novo != antigo) {
				clearTimeout(this.timeBusca)
				this.timeBusca = setTimeout(this.carregarListaPassageiros, 400)
			}
		}
	},
	mounted() {
		this.carregarGrupos()
		this.carregarListaPassageiros()
		this.carregarListaAtencaoEspecial()
		this.observer = new IntersectionObserver(this.infiniteScroll)
		console.log(this.$refs.load)
	},
	methods: {
		addQuantidadeEstimada() {
			this.form.quantidade_estimada_passageiros =
				Number(this.form.quantidade_estimada_passageiros) + 1
		},
		subQuantidadeEstimada() {
			if (Number(this.form.quantidade_estimada_passageiros) > 0) {
				this.form.quantidade_estimada_passageiros =
					Number(this.form.quantidade_estimada_passageiros) - 1
			}
		},
		buscaServeSide(search) {
			this.search = search
		},
		async onOpen() {
			if (this.hasNextPage) {
				await this.$nextTick()
				this.observer.observe(this.$refs.load[0])
			}
		},
		onClose() {
			this.observer.disconnect()
		},
		async infiniteScroll([{isIntersecting, target}]) {
			if (isIntersecting) {
				const ul = target.offsetParent
				const scrollTop = target.offsetParent.scrollTop
				const retorno = await new Promise((resolve) => {
					const page = Number(this.listaPassageiros.pagination.page) + 1
					let rota = `/Passageiro/lista?page=${page}`
					if (this.search) {
						rota += `&search=${this.search}`
					}
					this._httpGet(rota, (retorno) => {
						if (retorno._request && retorno._status) {
							retorno.lista.map((passageiro) => {
								passageiro.id_passageiro = passageiro.id
								passageiro.orgao = passageiro.id_orgao_apoiado
								passageiro.peso = parseFloat(passageiro.peso, 2)
								return passageiro
							})
							resolve(retorno)
						}
					})
				})
				this.listaPassageiros.lista = [
					...this.listaPassageiros.lista,
					...retorno.lista
				]
				this.listaPassageiros.pagination = retorno.pagination
				await this.$nextTick()
				ul.scrollTop = scrollTop
			}
		},
		atualizarTrecho(trecho) {
			trecho.esta = !trecho.esta
			this.$forceUpdate()
		},
		abrirCadastroPassageiro(index) {
			this.$refs.formCadastroPassageiro.modalShow(80)
			this.indexCadastro = index
		},

		carregarPassageiroRecemSalvo(passageiro) {
			passageiro.trecho = []
			if (this.possuiTrechos) {
				this.form.trecho.forEach((trecho, indexFormTrecho) => {
					passageiro.trecho.push({...trecho, esta: true})
				})
			}
			this.$refs.formCadastroPassageiro.modalHide()
			passageiro.peso = parseFloat(passageiro.peso).toFixed(2)
			this.listaPassageiros.lista.push(passageiro)
			this.form.passageiro[this.indexCadastro] = passageiro
			this.form.passageiro[this.indexCadastro].orgao =
				passageiro.id_orgao_apoiado
		},

		carregarPassageiro(val, index) {
			if (!val) {
				if (this.form.passageiro[index]) {
					this.$set(this.form.passageiro, index, this.passageiroLimpo())
				}
				return
			}
			if (!val.trecho || !val.trecho.length) {
				val.trecho = []
			}
			if (this.possuiTrechos) {
				this.form.trecho.forEach((trecho, indexFormTrecho) => {
					val.trecho.push({...trecho, esta: true})
				})
			}

			if (this.form.passageiro.length > 0) {
				if (
					this.form.passageiro.find(
						(pass) => val.id_passageiro == pass.id_passageiro
					)
				) {
					window.bus.$emit('exibir-notificacao', {
						type: 'danger',
						text: this._traducao('global', 'voceJaAddEssePerfil')
					})
				} else {
					this.$set(this.form.passageiro, index, val)
				}
			}
		},

		carregarListaAtencaoEspecial() {
			this._httpGet('/Tipo_atencao_especial/lista', (retorno) => {
				if (retorno._request && retorno._status) {
					this.listaAtencaoEspecial = retorno.lista
				}
			})
		},

		carregarListaPassageiros() {
			let rota = '/Passageiro/lista'
			if (this.search) {
				rota += `?search=${this.search}`
			}
			this._httpGet(rota, (retorno) => {
				if (retorno._request && retorno._status) {
					retorno.lista.map((passageiro) => {
						passageiro.id_passageiro = passageiro.id
						passageiro.orgao = passageiro.id_orgao_apoiado
						passageiro.peso = parseFloat(passageiro.peso, 2)
						// passageiro.cpf = passageiro.cpf.replace('-', '').replace('.', '')
						return passageiro
					})
					this.listaPassageiros = retorno
				}
			})
		},

		carregarPassageiroGrupo() {
			this._httpGet('/Passageiro/grupo/' + this.grupoSelecionado, (retorno) => {
				if (retorno._request && retorno._status) {
					this.form.passageiro = retorno.lista
					this.form.passageiro.map((passageiro) => {
						passageiro.id_passageiro = passageiro.id
						passageiro.orgao = passageiro.id_orgao_apoiado
						passageiro.peso = parseFloat(passageiro.peso, 2)
						passageiro.trecho = []
						if (this.possuiTrechos) {
							this.form.trecho.forEach((trecho) => {
								passageiro.trecho.push({
									...trecho,
									...passageiro.trecho,
									esta: true
								})
							})
						}
					})
					this.form.passageiros = this.form.passageiro.length
				}
			})
		},

		carregarGrupos() {
			this._httpGet('/Grupo_passageiro/lista', (retorno) => {
				if (retorno._request && retorno._status) {
					this.grupos = retorno.lista
				}
			})
		},

		// ADD PASSAGEIROS CASO HAJA
		addPassageiro(sinal) {
			if (sinal == '+') {
				let passageiro = this.passageiroLimpo()

				if (this.possuiTrechos) {
					for (var i in this.form.trecho) {
						passageiro.trecho.push({...this.form.trecho[i], esta: true})
					}
				}

				this.form.passageiro.push(passageiro)
			}

			if (sinal == '-') {
				this.passageirosExcluidos.push({
					...this.form.passageiro[this.form.passageiro.length - 1]
				})
				this.passageirosExcluidos = this.passageirosExcluidos.filter(
					(pass) => pass.id != pass.id_passageiro
				)
				this.form.passageiro.splice(this.form.passageiro.length - 1, 1)

				window.bus.$emit('lista-excluir-passageiros', this.passageirosExcluidos)
			}

			this.form.passageiros = this.form.passageiro.length
		},

		excluirPassageiro(passageiro) {
			let index = this.form.passageiro.findIndex(
				(pass) => pass.id == passageiro.id
			)
			this.passageirosExcluidos.push(this.form.passageiro[index])
			this.passageirosExcluidos = this.passageirosExcluidos.filter(
				(pass) => pass.id != pass.id_passageiro
			)
			this.form.passageiro.splice(index, 1)

			window.bus.$emit('lista-excluir-passageiros', this.passageirosExcluidos)

			this.form.passageiros = this.form.passageiro.length
		},

		passageiroLimpo() {
			return {
				id: 0,
				nome: '',
				nomeErro: '',
				orgao: '',
				orgaoErro: '',
				cargo: '',
				cargoErro: '',
				cpf: '',
				cpfErro: '',
				rg: '',
				matricula: '',
				passaporte: '',
				passaporteErro: '',
				estrangeiro: false,
				telefone: '',
				telefoneErro: '',
				hospedagem: false,
				atencao_especial: false,
				trecho: [],
				trechoErro: ''
			}
		},

		limparErrosAoAlterarEstrangeiro(passageiro) {
			if (passageiro.estrangeiro && passageiro.cpfErro && !passageiro.cpf) {
				passageiro.cpfErro = ''
			}
			if (!passageiro.estrangeiro && passageiro.passaporteErro) {
				passageiro.passaporteErro = ''
			}
		}
	},
	computed: {
		hasNextPage() {
			return (
				this.listaPassageiros.pagination.page <
				this.listaPassageiros.pagination.pages
			)
		},
		flagSimples() {
			return this.flagComponente === 'simples'
		},
		flagCompleto() {
			return this.flagComponente === 'completo'
		}
	},
	created() {
		this._providerOrgaoApoiado((lista) => {
			this.orgaosApoiados = lista
		})
	}
}
</script>
<style>
.loader {
	text-align: center;
	color: #bbbbbb;
}
</style>